module.exports = __webpack_public_path__ + "img/badge-fastest-lead-pickup-silver.55c45686.png";